import { Box, Button } from "@mui/material";
import DateRangeField from "components/ui/dateRangeField";
import MultiSelect from "components/ui/multiSelect";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import getInitialvalues from "../../utils/filterInitialValues";
import Select from "components/ui/select";
import useQueries from "hooks/useQueries";

const MainScreenFilter = ({
  setReload,
  setFilters,
  setPagination,
  pagination,
  filters,
  isFiltering,
  references,
  banks,
  customers,
  bankInvoiceStatuses,
  paymentMethods,
}) => {
  const { setQueries } = useQueries();
  const [reset, setReset] = useState(false);

  const initialValues = getInitialvalues(filters);

  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    setQueries({}); // Clear queries in URL
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
    setReset((pre) => !pre);
  };

  return (
    <Box
      p="15px 20px 5px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
        gap: "18px",
      }}
    >
      <MultiSelect
        options={customers}
        label="Customers"
        value={formik?.values?.customer_id}
        onChange={(value) => formik.setFieldValue("customer_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      {/* <MultiSelect
        options={references}
        label="References"
        value={formik?.values?.reference_id}
        onChange={(value) => formik.setFieldValue("reference_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      /> */}
      {/* <MultiSelect
        options={banks}
        label="Banks"
        value={formik?.values?.bank_id}
        onChange={(value) => formik.setFieldValue("bank_id", value)}
        selectProps={{ id: "id", label: "name" }}
      /> */}
      <DateRangeField
        label="Followup Date"
        from="followup_date_from"
        to="followup_date_to"
        formik={formik}
        key={`followup-${reset}-${formik.values.followup_date_from}-${formik.values.followup_date_to}`}
      />{" "}
      <Select
        name="expected_payment_type"
        options={[
          {
            id: "installation_fee",
            name: "Installation Fee",
          },
          {
            id: "charge",
            name: "Charge",
          },
          {
            id: "website",
            name: "Website Fee",
          },
        ]}
        label="Installment"
        formik={formik}
        selectProps={{ id: "id", label: "name" }}
      />{" "}
      <Select
        name="payment_method_id"
        options={paymentMethods}
        label="Select Payment Method"
        formik={formik}
        selectProps={{ id: "id", label: "name" }}
      />{" "}
      <MultiSelect
        options={bankInvoiceStatuses}
        label="Bank Invoice Status"
        value={formik?.values?.bank_invoice_status_id}
        onChange={(value) =>
          formik.setFieldValue("bank_invoice_status_id", value)
        }
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
      >
        <Button
          variant="solid"
          onClick={formik.submitForm}
          disabled={!formik.dirty}
        >
          Filter
        </Button>
        <Button
          variant="outlined"
          disabled={!isFiltering()}
          onClick={resetForm}
        >
          Reset Filter
        </Button>
      </Box>
    </Box>
  );
};

export default MainScreenFilter;
